import { useState } from "react";
import { Link } from "react-router-dom";
import { Heart, Star } from "lucide-react";
import { formatPrice, propertyImage } from "@/lib/api";
import { useFavorites } from "@/context/FavoritesContext";

export const PropertyCard = ({ prop }) => {
  const { ids, toggle } = useFavorites();
  const [pop, setPop] = useState(false);
  const saved = ids.includes(prop.property_id);

  const specs = [prop.bedrooms ? `${prop.bedrooms} BHK` : null, prop.area_sqft ? `${prop.area_sqft} sqft` : null,
    prop.furnishing ? prop.furnishing.replace("-", " ") : null].filter(Boolean).join(" · ");

  return (
    <div className="group relative" data-testid={`property-card-wrapper-${prop.property_id}`}>
      <button
        onClick={() => {
          setPop(true);
          setTimeout(() => setPop(false), 340);
          toggle(prop.property_id);
        }}
        className="absolute right-3 top-3 z-10"
        aria-label="Shortlist"
        data-testid={`shortlist-btn-${prop.property_id}`}
      >
        <Heart
          className={`h-6 w-6 drop-shadow-[0_1px_2px_rgba(0,0,0,0.4)] transition-colors duration-200 ${pop ? "heart-pop" : ""} ${
            saved ? "fill-primary text-primary" : "fill-black/25 text-white"
          }`}
          strokeWidth={2}
        />
      </button>

      <Link to={`/property/${prop.property_id}`} className="block" data-testid={`property-card-${prop.property_id}`}>
        <div className="relative overflow-hidden rounded-xl aspect-[4/3] sm:aspect-[20/19] bg-muted">
          <img
            src={propertyImage(prop)}
            alt={prop.title}
            loading="lazy"
            className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500 ease-out"
          />
          <div className="pointer-events-none absolute inset-x-0 top-0 h-20 bg-gradient-to-b from-black/25 to-transparent" />
          {prop.featured && (
            <span className="absolute left-3 top-3 rounded-full bg-background px-3 py-1 text-[11px] font-bold shadow-search">
              Guest favourite
            </span>
          )}
        </div>

        <div className="pt-2.5 sm:pt-3">
          <div className="flex items-start justify-between gap-2 sm:gap-3">
            <p className="font-display text-[13.5px] sm:text-[15px] leading-snug line-clamp-1">
              {prop.locality ? `${prop.locality}, ` : ""}
              {prop.city}
            </p>
            <span className="flex shrink-0 items-center gap-1 text-[12px] sm:text-[13px]">
              <Star className="h-3.5 w-3.5 fill-foreground" /> {(4.5 + ((prop.views || 0) % 5) / 10).toFixed(1)}
            </span>
          </div>
          <p className="mt-0.5 text-[12px] sm:text-[13px] text-muted-foreground line-clamp-1">{prop.title}</p>
          {specs && <p className="text-[12px] sm:text-[13px] text-muted-foreground line-clamp-1">{specs}</p>}
          <p className="mt-1 sm:mt-1.5 text-[14px] sm:text-[15px] font-bold">
            {formatPrice(prop.price, prop.listing_type)}
            {prop.listing_type === "sell" && <span className="hidden sm:inline font-normal text-muted-foreground"> · for sale</span>}
          </p>
        </div>
      </Link>
    </div>
  );
};

export default PropertyCard;
